import React from 'react'
import PanelMemberTemplate from '../../components/PanelMemberTemplate'
import { Sobia_data } from '../../assets'

const SobiaHasan = () => {
  return (
    <>
    <PanelMemberTemplate {...Sobia_data}/>
    </>
  )
}

export default SobiaHasan
